module.exports = __webpack_public_path__ + "img/logo-pic.b2589efd.png";